import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '@/utils/cn'

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-neutral-950 focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-primary-600 text-white shadow hover:bg-primary-700',
        secondary:
          'border-transparent bg-neutral-100 text-neutral-900 hover:bg-neutral-200',
        destructive:
          'border-transparent bg-destructive-600 text-white shadow hover:bg-destructive-700',
        success:
          'border-transparent bg-success-600 text-white shadow hover:bg-success-700',
        warning:
          'border-transparent bg-warning-500 text-white shadow hover:bg-warning-600',
        outline: 'text-neutral-950',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }